(() => {
  const roots = document.querySelectorAll('[data-ics-search-results]');

  roots.forEach((root) => {
    const panel = root.querySelector('[data-search-panel]');
    const error = root.querySelector('[data-search-error]');
    const forms = root.querySelectorAll('[data-search-navigation]');

    const showError = () => {
      if (error) error.hidden = false;
      if (panel) panel.setAttribute('aria-busy', 'false');
    };

    const hideError = () => {
      if (error) error.hidden = true;
    };

    const setLoading = () => {
      hideError();
      if (panel) panel.setAttribute('aria-busy', 'true');
    };

    forms.forEach((form) => {
      form.addEventListener('submit', (event) => {
        if (!navigator.onLine) {
          event.preventDefault();
          showError();
          return;
        }
        setLoading();
      });
    });

    root.querySelectorAll('[data-search-auto-submit]').forEach((select) => {
      select.addEventListener('change', () => {
        if (!navigator.onLine) {
          showError();
          return;
        }
        setLoading();
        select.form?.requestSubmit();
      });
    });

    root.querySelectorAll('[data-search-pagination] a').forEach((link) => {
      link.addEventListener('click', (event) => {
        if (!navigator.onLine) {
          event.preventDefault();
          showError();
          return;
        }
        setLoading();
      });
    });

    window.addEventListener('online', hideError);
    window.addEventListener('offline', showError);
    window.addEventListener('pageshow', () => {
      if (panel) panel.setAttribute('aria-busy', 'false');
    });
  });
})();
